import { Autowired, Bean, PostConstruct } from "../../context/context";
import { IComponent } from "../../interfaces/iComponent";
import { DyGridComponentFunctionInput } from "./userComponentRegistry";
import { DyComponentUtils } from "./dyComponentUtils";
import { BeanStub } from "../../context/beanStub";

export interface ComponentMetadata {
  mandatoryMethodList: string[];
  optionalMethodList: string[];
  functionAdapter?: (callback: DyGridComponentFunctionInput) => { new(): IComponent<any> };
}

@Bean("componentMetadataProvider")
export class ComponentMetadataProvider extends BeanStub {

  private componentMetaData: { [key: string]: ComponentMetadata };

  @Autowired("dyComponentUtils")
  private dyComponentUtils: DyComponentUtils;

  @PostConstruct
  public postConstruct() {
    this.componentMetaData = {
      dateComponent: {
        mandatoryMethodList: ['getDate', 'setDate'],
        optionalMethodList: ['afterGuiAttached', 'setInputPlaceholder', 'setInputAriaLabel']
      },
      detailCellRenderer: {
        mandatoryMethodList: [],
        optionalMethodList: ['refresh']
      },
      headerComponent: {
        mandatoryMethodList: [],
        optionalMethodList: ['refresh']
      },
      headerGroupComponent: {
        mandatoryMethodList: [],
        optionalMethodList: []
      },
      loadingCellRenderer: {
        mandatoryMethodList: [],
        optionalMethodList: []
      },
      loadingOverlayComponent: {
        mandatoryMethodList: [],
        optionalMethodList: []
      },
      noRowsOverlayComponent: {
        mandatoryMethodList: [],
        optionalMethodList: []
      },
      floatingFilterComponent: {
        mandatoryMethodList: ['onParentModelChanged'],
        optionalMethodList: ['afterGuiAttached']
      },
      floatingFilterWrapperComponent: {
        mandatoryMethodList: [],
        optionalMethodList: []
      },
      cellRenderer: {
        mandatoryMethodList: [],
        optionalMethodList: ['refresh', 'afterGuiAttached'],
        functionAdapter: this.dyComponentUtils.adaptCellRendererFunction.bind(this.dyComponentUtils)
      },
      cellEditor: {
        mandatoryMethodList: ['getValue'],
        optionalMethodList: ['isPopup', 'isCancelBeforeStart', 'isCancelAfterEnd', 'getPopupPosition', 'focusIn', 'focusOut', 'afterGuiAttached']
      },
      innerRenderer: {
        mandatoryMethodList: [],
        optionalMethodList: ['afterGuiAttached'],
        functionAdapter: this.dyComponentUtils.adaptCellRendererFunction.bind(this.dyComponentUtils)
      },
      fullWidthCellRenderer: {
        mandatoryMethodList: [],
        optionalMethodList: ['refresh', 'afterGuiAttached'],
        functionAdapter: this.dyComponentUtils.adaptCellRendererFunction.bind(this.dyComponentUtils)
      },
      pinnedRowCellRenderer: {
        mandatoryMethodList: [],
        optionalMethodList: ['refresh', 'afterGuiAttached'],
        functionAdapter: this.dyComponentUtils.adaptCellRendererFunction.bind(this.dyComponentUtils)
      },
      groupRowRenderer: {
        mandatoryMethodList: [],
        optionalMethodList: ['afterGuiAttached'],
        functionAdapter: this.dyComponentUtils.adaptCellRendererFunction.bind(this.dyComponentUtils)
      },
      filter: {
        mandatoryMethodList: ['isFilterActive', 'doesFilterPass', 'getModel', 'setModel'],
        optionalMethodList: ['afterGuiAttached', 'onNewRowsLoaded', 'getModelAsString', 'onFloatingFilterChanged']
      },
      filterComponent: {
        mandatoryMethodList: ['isFilterActive', 'doesFilterPass', 'getModel', 'setModel'],
        optionalMethodList: ['afterGuiAttached', 'onNewRowsLoaded', 'getModelAsString', 'onFloatingFilterChanged']
      },
      statusPanel: {
        mandatoryMethodList: [],
        optionalMethodList: ['afterGuiAttached'],
      },
      toolPanel: {
        mandatoryMethodList: [],
        optionalMethodList: ['refresh', 'afterGuiAttached']
      },
      tooltipComponent: {
        mandatoryMethodList: [],
        optionalMethodList: []
      }
    };
  }

  public retrieve(name: string): ComponentMetadata {
    return this.componentMetaData[name];
  }
}
